document.addEventListener('click', function (e) {
  var btn = e.target.closest('.qdh-offers__copy');
  if (!btn) return;
  var code = btn.dataset.code;
  var done = function () {
    btn.textContent = 'Copied!';
    btn.classList.add('qdh-offers__copy--done');
    setTimeout(function () {
      btn.textContent = 'Copy';
      btn.classList.remove('qdh-offers__copy--done');
    }, 2000);
  };
  if (navigator.clipboard) {
    navigator.clipboard.writeText(code).then(done).catch(function () {
      fallbackCopy(code, done);
    });
  } else {
    fallbackCopy(code, done);
  }
});

function fallbackCopy(code, cb) {
  var ta = document.createElement('textarea');
  ta.value = code;
  ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  try { document.execCommand('copy'); } catch (e) {}
  document.body.removeChild(ta);
  cb();
}
